import { render, staticRenderFns } from "./PhoneNoLeave.vue?vue&type=template&id=26a8712e&scoped=true"
import script from "./PhoneNoLeave.vue?vue&type=script&lang=js"
export * from "./PhoneNoLeave.vue?vue&type=script&lang=js"
import style0 from "./PhoneNoLeave.vue?vue&type=style&index=0&id=26a8712e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a8712e",
  null
  
)

export default component.exports